var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showPopup),expression:"showPopup"}],staticClass:"popup"},[_c('div',{class:_vm.maskClass,on:{"click":_vm.clickMask}}),_c('div',{class:_vm.mainClass},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }